import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { DeviceMobile, CircleNotch } from "@phosphor-icons/react";
import { fmtDate } from "./meta";

// Recherche du mobile professionnel (Prospeo) : 10 crédits facturés uniquement si un numéro vérifié est trouvé.
export function MobileFinder({ siren, kind, id, name, searchedAt, reload }) {
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/leads/companies/${siren}/${kind}/${id}/find-mobile`, { confirm: true });
      if (data.found) toast.success(`Mobile trouvé : ${data.contact?.phone}${data.credits ? ` · ${data.credits} crédits` : " · déjà payé, sans frais"}${data.contact?.email ? ` · email : ${data.contact.email}` : ""}`);
      else toast.info(data.reason || "Aucun mobile vérifié trouvé : aucun crédit consommé.");
      reload();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (searchedAt) return <span className="text-[10px] text-muted" data-testid={`lead-mobile-none-${id}`}>aucun mobile trouvé ({fmtDate(searchedAt)})</span>;
  return (
    <>
      <button onClick={() => setAsk(true)} disabled={busy} title="Recherche Prospeo du mobile professionnel" data-testid={`lead-find-mobile-${id}`}
        className="flex items-center gap-1 text-[11px] border border-border rounded px-2 py-0.5 hover:border-accent/40 disabled:opacity-60 whitespace-nowrap">
        {busy ? <CircleNotch size={11} className="animate-spin" /> : <DeviceMobile size={11} />} Trouver le mobile · 10 crédits
      </button>
      <AlertDialog open={ask} onOpenChange={setAsk}>
        <AlertDialogContent className="bg-surface border-border" data-testid={`lead-find-mobile-dialog-${id}`}>
          <AlertDialogHeader>
            <AlertDialogTitle>Trouver le mobile de {name || "ce contact"} ?</AlertDialogTitle>
            <AlertDialogDescription>
              Prospeo facture 10 crédits uniquement si un mobile professionnel vérifié est trouvé (l'email est alors fourni gratuitement s'il existe). Aucun crédit n'est consommé sinon.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`lead-find-mobile-cancel-${id}`}>Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={run} className="bg-accent text-black hover:bg-accent/90" data-testid={`lead-find-mobile-confirm-${id}`}>Lancer la recherche</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
